import * as z from "zod"
import { DBDispatchOrderType } from ".prisma/client"
import { CompleteDBClient, RelatedDBClientModel, CompleteDBFile, RelatedDBFileModel, CompleteDBUser, RelatedDBUserModel } from "./index"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const DBDispatchModel = z.object({
  id: z.string(),
  clientId: z.string(),
  orderType: z.nativeEnum(DBDispatchOrderType),
  orderId: z.string(),
  orderDetails: jsonSchema,
  deliveryId: z.string(),
  deliveryDetails: jsonSchema,
  lineItems: jsonSchema,
  recipient: z.string(),
  recipientSignatureId: z.string(),
  userId: z.string(),
  startedAt: z.date(),
  finishedAt: z.date(),
})

export interface CompleteDBDispatch extends z.infer<typeof DBDispatchModel> {
  client: CompleteDBClient
  recipientSignature: CompleteDBFile
  user: CompleteDBUser
}

/**
 * RelatedDBDispatchModel contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
export const RelatedDBDispatchModel: z.ZodSchema<CompleteDBDispatch> = z.lazy(() => DBDispatchModel.extend({
  client: RelatedDBClientModel,
  recipientSignature: RelatedDBFileModel,
  user: RelatedDBUserModel,
}))
